import React from "react";
import {Modal} from 'antd';
import getSize from "../../../../utils/getSize";
import NHFetch from "../../../../utils/NHFetch";
import JxXsjfxxcx from "../jxXsjfxxcx";//基线
import ScjtXsjfxxcx from "../scjtXsjfxxcx";//四川交通

const confirm = Modal.confirm;

const baseUrlPath = "/yxxt"; //基础路径

//学生缴费信息查询——项目地定制菜单配置

class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCode: [],//null是基线
        };
    }

    componentDidMount() {
        this.getMenuCode();
    }

    getMenuCode = () => {
        let cds = ["xsjfxxcx"];
        NHFetch(baseUrlPath + '/getXmdcd', 'POST', cds).then(res => {
            if (res) {
                if (res && res.code == 200) {
                    let menuCode = res.data;
                    this.setState({
                        menuCode
                    })
                }
            }
        });
    }

    render() {
        const {menuCode} = this.state;
        return (
          <div>
              {
                  menuCode && menuCode.length > 0 && menuCode.map((item, index) => {
                      if(item.JC == "scjt") {
                          return <ScjtXsjfxxcx/>   
                      } else {
                          return <JxXsjfxxcx/>
                      }
                  })
              }
              {(menuCode == null || menuCode.length == 0) && <JxXsjfxxcx/>}
          </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./components/tjcx/xsjfxxcx/xsjfxxcxMenuConfig/index.js